// frontend/config/firebaseConfig.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";

export const firebaseConfig = {
  apiKey: "AIzaSyC8fiS4dslj-V4VgEuVuNM-5ffM_Hi5q6I",
  authDomain: "clipboard-93115.firebaseapp.com",
  projectId: "clipboard-93115",
  storageBucket: "clipboard-93115.firebasestorage.app",
  messagingSenderId: "273778246347",
  appId: "1:273778246347:web:fc0ce064d4aa864633914e",
  measurementId: "G-EWGS6P9LV7",
};

// Evita re-inicializar en HMR/SSR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// SDKs que usarás en el cliente
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Analytics solo en navegador y si el entorno lo soporta
export const analyticsPromise = typeof window !== "undefined"
  ? isSupported().then((ok) => (ok ? getAnalytics(app) : null))
  : Promise.resolve(null);

export default app;
